import { AlertCircle, Inbox, LoaderCircle } from "lucide-react";

export function LoadingState({ label = "Ladataan tietoja…" }: { label?: string }) {
  return <div className="state"><LoaderCircle className="spin" /><p>{label}</p></div>;
}

export function ErrorState({ message = "Tietojen lataaminen epäonnistui." }: { message?: string }) {
  return <div className="state state--error"><AlertCircle /><p>{message}</p></div>;
}

export function EmptyState({ title, text }: { title: string; text: string }) {
  return <div className="state"><span className="state__icon"><Inbox /></span><h3>{title}</h3><p>{text}</p></div>;
}

